import React from "react";
import moment from "moment";
import { useNavigate } from "react-router";

const CustomerTable = ({ setFirst, userInfo, customers }) => {
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFirst((prev) => {
      const valid = prev.map((cust) => cust.customer_id === e.customer_id);
      if (valid.includes(true)) {
        return prev.filter((val) => val.customer_id !== e.customer_id);
      } else {
        return [...prev, e];
      }
    });
  };

  return (
    <div>
      <div className="w-full overflow-x-auto">
        <table className="table-auto w-[1400px] overflow-x-auto xl:w-full text-[#414552] customer-table">
          <thead className="text-[11px]">
            <tr className="border-b-[1px] border-[#ebeef1]">
              <th className="w-[50px]">
                <div className="flex justify-start mx-2">
                  <input
                    id="active-column-main"
                    name="active-column-main"
                    type="checkbox"
                    className="h-[14px] w-[14px] rounded border-gray-300 accent-indigo-600 focus:outline-none"
                  />
                </div>
              </th>
              <th className="font-medium">NAME</th>
              {userInfo.email && <th className="font-medium">EMAIL</th>}
              {userInfo.defaultMethod && (
                <th className="font-medium">DEFAULT PAYMENT METHOD</th>
              )}
              {userInfo.subscription && (
                <th className="font-medium">SUBSCRIPTION</th>
              )}
              {userInfo.created && <th className="font-medium">CREATED</th>}
              {userInfo.customer && <th className="font-medium">CUSTOMER</th>}
              {userInfo.description && (
                <th className="font-medium">DESCRIPTION</th>
              )}
              {userInfo.customerID && (
                <th className="font-medium">CUSTOMER ID</th>
              )}
              {userInfo.cardName && (
                <th className="font-medium">CARDHOLDER NAME</th>
              )}
            </tr>
          </thead>
          <tbody className="text-[14px]">
            {customers.map(
              (val) =>
                !val._deleted && (
                  <tr
                    key={val.customer_id}
                    className="hover:bg-[#f6f8fa] cursor-pointer border-b-[1px] border-[#ebeef1]"
                  >
                    <td className="w-[50px]">
                      <div className="flex justify-start mx-2">
                        <input
                          id="id"
                          name="active-column"
                          type="checkbox"
                          className="h-[14px] w-[14px] rounded border-gray-300 accent-indigo-600 focus:outline-none"
                          onChange={() => handleChange(val)}
                        />
                      </div>
                    </td>
                    <td className="font-semibold" onClick={() => navigate(`/customers/${val.customer_id}`)}>{val?.name}</td>
                    {userInfo.email && (
                      <td className="text-[#687385]" onClick={() => navigate(`/customers/${val.customer_id}`)}>{val.account_email}</td>
                    )}
                    {userInfo.defaultMethod && (
                      <td className="text-[#687385]" onClick={() => navigate(`/customers/${val.customer_id}`)}></td>
                    )}
                    {userInfo.subscription && (
                      <td className="text-[#687385]" onClick={() => navigate(`/customers/${val.customer_id}`)}>---</td>
                    )}
                    {userInfo.created && (
                      <td className="text-[#687385]" onClick={() => navigate(`/customers/${val.customer_id}`)}>
                        {moment(val.inserted_dt).format("MMMM DD, h:mm a")}
                      </td>
                    )}
                    {userInfo.customer && (
                      <td className="text-[#687385]" onClick={() => navigate(`/customers/${val.customer_id}`)}>
                        {val.account_email}---{val.customer_id}
                      </td>
                    )}
                    {userInfo.description && <td className="text-[#687385]" onClick={() => navigate(`/customers/${val.customer_id}`)}>{val.description}</td>}
                    {userInfo.customerID && (
                      <td className="text-[#687385]">{val.customer_id}</td>
                    )}

                    {userInfo.cardName && <td className="text-[#687385]" onClick={() => navigate(`/customers/${val.customer_id}`)}>---</td>}
                  </tr>
                )
            )}
          </tbody>
        </table>
      </div>
      <div className="flex justify-between items-center mt-2">
        <span className="text-[#687385] text-sm">
          <b>{customers.length}</b> results
        </span>
        <div className="flex gap-2">
          <button
            className="border-[2px] h-[28px] rounded-[6px] border-[#ebeef1] text-[12px] font-semibold p-[0_8px] opacity-60"
            disabled
          >
            Previous
          </button>
          <button
            className="border-[2px] h-[28px] rounded-[6px] border-[#ebeef1] text-[12px] font-semibold p-[0_8px] opacity-60"
            disabled
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomerTable;
